var English = "영어";
var French = "프랑스어";
var German = "독일어";
var Italian = "이탈리아어";
var Japanese = "일본어";
var Korean = "한국어";
var Portuguese = "포르투갈어";
var Russian = "러시아어";
var Spanish = "스페인어";
var Bahasa = "말레이/인도네시아어";
var Thai = "태국어";
var Vietnamese = "베트남어";
var Turkish = "터키어";
var Arabic = "아랍어";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "중국어 간체",
	"Chinese-Traditional": "중국어 번체",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
